import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const loginJwt = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("rebel_jwt", data.token);
    setUser(data.user);
    return data.user;
  };
  const signupJwt = async (payload) => {
    const { data } = await api.post("/auth/signup", payload);
    localStorage.setItem("rebel_jwt", data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem("rebel_jwt");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, loginJwt, signupJwt, logout, refresh: checkAuth }}>
      {children}
    </AuthCtx.Provider>
  );
}
